export default {
  hero_label: 'Recruit',
  hero_title: '採用情報',
  hero_subtitle: 'AIで日本の未来を創る仲間を、\n私たちは求めています。',
  jobs_title: '募集職種',
  process_title: '応募の流れ',
  process_1_step: '01',
  process_1_title: 'エントリー',
  process_1_desc: 'Webフォームより応募',
  process_2_step: '02',
  process_2_title: '書類選考',
  process_2_desc: '履歴書・職務経歴書の審査',
  process_3_step: '03',
  process_3_title: '適性診断',
  process_3_desc: 'オンライン適性検査を実施',
  process_4_step: '04',
  process_4_title: '面接',
  process_4_desc: '1〜2回の面接を実施',
  process_5_step: '05',
  process_5_title: '内定',
  process_5_desc: '条件面談・入社日調整',
  benefits_title: '働く環境',
  benefit_1_title: 'AI最前線の経験',
  benefit_1_desc: '最先端のAI技術とビジネス変革の現場で実践的なスキルを磨ける環境',
  benefit_2_title: 'ワークライフバランス',
  benefit_2_desc: 'フレックスタイム制・リモートワーク可で柔軟な働き方を実現',
  benefit_3_title: '充実の福利厚生',
  benefit_3_desc: '各種社会保険完備・資格取得支援・学習補助制度',
  benefit_4_title: 'AI教育制度',
  benefit_4_desc: 'AI・DX関連の社内研修・外部セミナー・資格取得を全額支援',
  benefit_5_title: 'グローバル展開',
  benefit_5_desc: '国内外のAI先進企業との協業・海外プロジェクトへの参画機会',
  benefit_6_title: '実力主義評価',
  benefit_6_desc: '成果と専門性に基づく明確な評価制度と報酬体系',
  cta_title: '一緒にAIで日本の未来を創りませんか',
  cta_desc: 'AI戦略・DX推進・人材育成のプロフェッショナルとして、ご応募をお待ちしています',
  cta_btn: 'エントリーする',
  modal_apply: 'この職種に応募する',
  modal_responsibilities: '業務内容',
  modal_requirements: '必須要件',
  modal_preferred: '歓迎要件',
  jobs: [
    {
      id: 1,
      title: 'AIコンサルタント',
      category: 'AIX Consulting',
      type: '正社員',
      location: '東京',
      description: 'クライアント企業のAI戦略立案からDX推進まで、一貫したコンサルティングサービスを提供します。',
      responsibilities: [
        'クライアントのAI活用課題のヒアリング・分析',
        'AI戦略・ロードマップの立案と実行支援',
        'AI導入による業務改革プロジェクトのリード',
        'ステークホルダーへの提案・プレゼンテーション'
      ],
      requirements: [
        'コンサルティング経験3年以上',
        'AI・機械学習に関する基礎知識',
        '課題解決型の論理的思考力',
        'ビジネスレベルの日本語力'
      ],
      preferred: [
        'DX推進プロジェクトの経験',
        'データ分析・統計に関する知識',
        'MBA取得者または同等の経験'
      ]
    },
    {
      id: 2,
      title: 'DX推進コンサルタント',
      category: 'AIX Consulting',
      type: '正社員',
      location: '東京',
      description: 'デジタル技術とAIを融合させ、企業のビジネスプロセス全体を変革するコンサルティングを担当します。',
      responsibilities: [
        'クライアント企業のDX現状診断と課題抽出',
        'DX推進戦略の策定と実行支援',
        'AI・データ活用基盤の導入アドバイザリー',
        'DX推進チームの組織支援・変革マネジメント'
      ],
      requirements: [
        'IT・デジタル領域のコンサルティング経験3年以上',
        'ビジネスプロセス改革の知識・経験',
        'プロジェクトマネジメント能力',
        'クライアントとの関係構築力'
      ],
      preferred: [
        'Salesforce / SAP等のエンタープライズシステム経験',
        'アジャイル・スクラム開発の経験',
        'デジタルトランスフォーメーション関連資格'
      ]
    },
    {
      id: 3,
      title: 'AI人材育成コンサルタント',
      category: 'AIX Training',
      type: '正社員',
      location: '東京',
      description: '企業内のAIリテラシー向上と人材育成プログラムの設計・実施を通じて、AI活用組織の構築を支援します。',
      responsibilities: [
        'AI人材育成プログラムの企画・設計・実施',
        '企業向けAIリテラシー研修のファシリテーション',
        '受講者の学習進捗・効果測定と改善提案',
        '育成カリキュラムのコンテンツ開発'
      ],
      requirements: [
        '研修・教育プログラムの企画・実施経験3年以上',
        'AI・データサイエンスに関する実務知識',
        '優れたプレゼンテーション・ファシリテーション能力',
        '教育効果の測定・分析スキル'
      ],
      preferred: [
        '大企業向け人材育成プロジェクトの経験',
        'AI・データ関連の資格保有',
        'eラーニングコンテンツ制作の経験'
      ]
    },
    {
      id: 4,
      title: 'AIマネジメントアドバイザー',
      category: 'AIX Manager',
      type: '正社員',
      location: '東京',
      description: 'AI組織マネジメントの観点から、企業のAI推進体制の構築と組織変革をリードするアドバイザリーを行います。',
      responsibilities: [
        'AI推進組織の設計・体制構築支援',
        'AI活用における意思決定プロセスの最適化',
        'AIガバナンス・リスク管理フレームワークの策定',
        '経営層へのAI戦略レポーティング・提言'
      ],
      requirements: [
        'マネジメント経験5年以上',
        '組織変革・チェンジマネジメントの知識',
        'AIプロジェクトのリード経験',
        '経営層とのコミュニケーション能力'
      ],
      preferred: [
        '大規模組織のAI推進プロジェクト経験',
        'PMO・組織コンサルティングの経験',
        'AIガバナンス・倫理に関する知識'
      ]
    }
  ]
};